define([
    'headroom'
], function(
    Headroom
){
    return {
        mounted: function(){
            var headroom = new Headroom(this.$el);
            headroom.init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/mixin/headroom.js
// module id = 28
// module chunks = 0 1 2 3